export default __webpack_public_path__ + "locales/ar-SA/ConvertPasswordDialog.json?hash=2591c9693ac4be61a21b37293d67249b";